import { createSelector } from '@reduxjs/toolkit';

import {
  selectActiveAccount,
  selectCashierConfiguration,
  selectPaymentInputs,
  selectPaymentMethod,
} from '@cashier/cashier-data-access';
import { InputTypes, PaymentMethodInput } from '@cashier/cashier-model';

import { AMOUNT_FIELD_NAME } from '../constants';
import { PreProcessorConverter } from '../helpers';

export const selectProcessingAttributes = createSelector(
  selectPaymentInputs,
  selectActiveAccount,
  selectPaymentMethod,
  selectCashierConfiguration,
  (fields, activeAccount, { preprocessor }, { amount }) => {
    const initialAttributes = activeAccount
      ? {
          amount: fields[AMOUNT_FIELD_NAME]?.value,
          accountId: activeAccount.value,
        }
      : { amount: fields[AMOUNT_FIELD_NAME]?.value };

    if (amount) {
      initialAttributes.amount = amount;
    }

    const getValue = (
      value: string | boolean | Array<string> | null,
      preprocessed: boolean,
    ): string | boolean | Array<string> | null => {
      if (typeof value !== 'string') {
        return value;
      }

      const trimmedValue = value.trim();

      return preprocessed && preprocessor
        ? PreProcessorConverter.convertInputData(trimmedValue, preprocessor)
        : trimmedValue;
    };

    return Object.entries(fields)
      .filter(([key, value]) => value.params?.shouldBeStripped !== true)
      .reduce((acc, [k, v]) => {
        const { value = null, type, name, params } = v as PaymentMethodInput;

        if (
          (!value &&
            type !== InputTypes.Select &&
            type !== InputTypes.Hidden) ||
          name === AMOUNT_FIELD_NAME
        ) {
          return acc;
        }

        return {
          ...acc,
          [k]: getValue(value, params?.preprocessed || false),
        };
      }, initialAttributes);
  },
);
